import { Class, Subject, ClassNote, Teacher } from '@/plugins/api'
import moment from 'moment'
import { groupBy, keyBy, orderBy, rangeRight } from 'lodash-es'

export default {
  namespaced: true,
  state: {
    loading: false,
    classNotes: [],
    pageText: '',
    itemsPerPage: 10,
    searchParams: {},
    totalItems: 0,
    date: moment().toISOString()
  },
  actions: {
    async searchTeachingReport({ commit, state, dispatch }, query) {
      const searchParams = {
        _limit: state.itemsPerPage,
        ...query
      }

      commit('changeState', { searchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.searchParams) {
        const searchParams = {
          ...state.searchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage
        }
        const [totalItems, classNotes] = await Promise.all([
          ClassNote.count(searchParams),
          ClassNote.search(searchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          const classNoteObj = keyBy(classNotes, 'id')

          for (const classNote of classNotes) {
            const [classData, subject, teacher] = await Promise.all([
              Class.fetchOne(classNote.slot.class),
              Subject.fetchOne(classNote.slot.subject),
              Teacher.fetchOne(classNote.slot.teacher)
            ])
            classNoteObj[classNote.id] = { ...classNote, class: classData, subject, teacher }
          }

          commit('changeState', {
            classNotes: Object.values(classNoteObj),
            totalItems,
            itemsPerPage,
            searchParams
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('changeState', {
            pageText
          })
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }

      commit('changeState', { loading: false })
    },
    // sorted by lessonIndex
    async fetchData({ commit }, query) {
      const classNotes = await ClassNote.search({ ...query, _limit: -1 })

      const classNoteObj = keyBy(classNotes, 'id')
      for (const classNote of classNotes) {
        const [classData, subject, teacher] = await Promise.all([
          Class.fetchOne(classNote.slot.class),
          Subject.fetchOne(classNote.slot.subject),
          Teacher.fetchOne(classNote.slot.teacher)
        ])
        classNoteObj[classNote.id] = { ...classNote, class: classData, subject, teacher }
      }

      const classNoteBySubjectObj = groupBy(Object.values(classNoteObj), 'subject.id')
      const sortedClassNotes = []
      for (const key of Object.keys(classNoteBySubjectObj)) {
        const items = classNoteBySubjectObj[key]
        const sortedArray = orderBy(items, ['data.lessonIndex'], ['desc'])
        if (sortedArray && sortedArray.length) sortedClassNotes.push(sortedArray[0])
      }
      commit('changeState', {
        classNotes: sortedClassNotes
      })
    },
    setDate({ commit }, date) {
      commit('changeState', {
        date
      })
    }
  },
  mutations: {
    //
  },
  getters: {
    startWeek: state => {
      const startWeek = moment(state.date).startOf('week')
      return startWeek
    },
    endWeek: state => {
      const endWeek = moment(state.date).endOf('week')
      return endWeek
    }
  }
}
